import * as React from 'react'

export function MapAddressIcon({
  disabled = false,
  color = '#1565C0',
  width = 16,
  height = 18,
  sx = {},
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 18"
      style={{ display: 'inline-block', ...sx }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.375 2.25L12.255 2.2725L8.25 3.825L3.75 2.25L-0.48 3.675C-0.6375 3.7275 -0.75 3.8625 -0.75 4.035V15.375C-0.75 15.585 -0.585 15.75 -0.375 15.75L-0.255 15.7275L3.75 14.175L8.25 15.75L12.48 14.325C12.6375 14.2725 12.75 14.1375 12.75 13.965V2.625C12.75 2.415 12.585 2.25 12.375 2.25ZM8.25 14.25L3.75 12.6675V3.75L8.25 5.3325V14.25Z"
        fill={disabled ? '#BDBDBD' : color}
      />
    </svg>
  )
}
